export default "__VITE_ASSET__D4ekiMyL__"